import { render, staticRenderFns } from "./SectionOfEpilepsyQuestions.vue?vue&type=template&id=22520856&"
import script from "./SectionOfEpilepsyQuestions.vue?vue&type=script&lang=js&"
export * from "./SectionOfEpilepsyQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports